import { styled } from '@mui/material';

import { useMemo } from 'react';

 import { Typography } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';
import { RepeatIcon, SkipLastIcon, SkipNextIcon } from '@app-velocity/icons';

export type LoopIndicatorProps = {
  variant: 'start' | 'finish' | 'step';
};

const LoopAlert = styled('div')(({ theme }) => ({
  background: 'var(--warning-warning-background-color)',
  border: '1px solid var(--warning-warning-stroke-color)',
  color: 'var(--warning-warning-text-primary-color)',
  fontWeight: 500,
  fontSize: 13,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  margin: 0,
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  svg: {
    fill: 'var(--warning-warning-icon-primary-color)',
  },
}));

const Title = styled('div')(({ theme }) => ({
  gap: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
}));

export const LoopIndicator = ({ variant }: LoopIndicatorProps) => {
  const { t } = useI18n();

  const title: I18nResources = useMemo(() => {
    switch (variant) {
      case 'start':
        return 'prototypes:loop_start';
      case 'finish':
        return 'prototypes:loop_finish';
      case 'step':
        return 'prototypes:loop_step';
    }
  }, []);

  const icon = useMemo(() => {
    switch (variant) {
      case 'start':
        return <SkipNextIcon />;
      case 'finish':
        return <SkipLastIcon />;
      case 'step':
        return <RepeatIcon />;
    }
  }, []);

  return (
    <LoopAlert>
      <Title>
        {icon}
        {t(title)}
      </Title>
      {['start', 'step'].includes(variant) ? (
        <Typography>{t('prototypes:loop_explanation')}</Typography>
      ) : null}
    </LoopAlert>
  );
};
